import { QuestionCircleFilled } from "@ant-design/icons";
import { Button, Card, Modal } from "antd";
import { HiOutlinePlusCircle } from "react-icons/hi";
import { useState } from "react";
import { useWindowSize } from "usehooks-ts";
import useMilken from "@/hooks/useMilken";

interface IAddCocCard {
  variant: "reach-max" | "pending";
  dataPending?: any[];
  modalConfigSet?: (payload: { key: "list-pending" | "info" }) => void;
  onClickAdd: () => void;
  totalLeft: any;
  className?: string;
}

export default function AddCocCard({
  variant,
  dataPending = [],
  modalConfigSet,
  onClickAdd,
  totalLeft,
  className,
}: IAddCocCard) {
  const [isOpenModalInfo, isOpenModalInfoSet] = useState(false);
  const { isConferenceOrIsMilken } = useMilken();

  function getContent() {
    switch (variant) {
      case "reach-max":
        return {
          title: (
            <p className="font-bold text-base">
              Maximum Number <br />
              of Champions{" "}
              <QuestionCircleFilled
                onClick={() => isOpenModalInfoSet(true)}
                className="text-base cursor-pointer"
              />
            </p>
          ),
          body: (
            <p className="text-xs text-neutral-300">
              You have already have <br />
              maximum number of champions
            </p>
          ),
        };
      case "pending":
        return {
          title: (
            <p className="font-bold text-base">
              Add Champions{" "}
              <QuestionCircleFilled
                onClick={() => isOpenModalInfoSet(true)}
                className="text-base cursor-pointer"
              />
            </p>
          ),
          body: (
            <>
              <p className="text-xs text-neutral-300">
                {dataPending.length} pending requests. <br />
                You have {totalLeft} invitation left.
              </p>
            </>
          ),
        };
    }
  }

  const { width } = useWindowSize();

  return (
    <>
      <Card
        key={`card-of-action`}
        bodyStyle={width < 768 ? { padding: 8, height: "100%" } : {}}
        className={className}
      >
        <div className="flex justify-center w-full text-neutral-300 hover:text-white h-full">
          <div className="flex flex-col items-center justify-center text-center gap-1">
            <p
              className={`${totalLeft > 0 && "cursor-pointer hover:scale-[.98]"}`}
              onClick={() =>
                totalLeft === 0 || variant === "reach-max" ? null : onClickAdd()
              }
            >
              <HiOutlinePlusCircle className="text-4xl lg:text-[48px] inline-block" />
            </p>
            {getContent().title}
            {getContent().body}
            {dataPending.length > 0 && (
              <Button
                style={{ marginTop: 16 }}
                onClick={() =>
                  modalConfigSet
                    ? modalConfigSet({ key: "list-pending" })
                    : null
                }
                type="primary"
              >
                List of Invitees
              </Button>
            )}
          </div>
        </div>
      </Card>
      <Modal
        open={isOpenModalInfo}
        title="Circle of Champions"
        footer={null}
        onCancel={() => isOpenModalInfoSet(false)}
      >
        <p>
          {isConferenceOrIsMilken
            ? "Circle of Champions is an honor bestowed upon 6 of your connections. "
            : "Circle of Champions is an honor bestowed upon the 6 most important connections to you within the organization. "}
          You can bestow this honor upon your Mentees, Mentors, Sponsors, or
          Connections. This is a great way to help them earn extra points or rewards.
        </p>
      </Modal>
    </>
  );
}
